import appConfig from '../../config/appConfig';
import stringUtils from '../../utils/stringUtils';
import iccMarketService from '../icc/iccMarketService';
import log from '../logger/log';
import server from '../server/server';
import defaultLocalizations from './default';
import languageService from './languageService';
import LocalizedStrings from './LocalizedStrings';

const fetchLocalizations = async (languageCode) => {
    if (!appConfig.getIsMarketInitialized()) return;

    const currentLanguageCode = languageCode || languageService.getCurrentLanguageCode();

    try {
        return await fetchLocalization(currentLanguageCode);
    } catch (e) {
        log.error(`fetchLocalizations: error: ${JSON.stringify(e)}`);
    }
};

const getLocalizationData = async (currentLanguageCode, localizationFileName) => {
    if (localizationFileName) {
        try {
            const formattedStrings = stringUtils.formatString(localizationFileName, currentLanguageCode.toLowerCase());
            const localizationAsset = await iccMarketService.getMediaUrl({
                mediaNameList: formattedStrings,
                throwException: true,
            });
            const localizationPath = localizationAsset[0]?.url;
            const {data} = await server.get(localizationPath);

            return data;
        } catch (e) {
            return null;
        }
    }
};

const fetchLocalizationByLanguageCode = async (languageCode) => {
    const specificLocalizationFileName = appConfig.getSpecificLocalizationFileName();
    const commonLocalizationFileName = appConfig.getCommonLocalizationFileName();
    const specificLocalizationData = await getLocalizationData(languageCode, specificLocalizationFileName);
    const commonLocalizationData = await getLocalizationData(languageCode, commonLocalizationFileName);
    const isLocalizationDataNotNull = commonLocalizationData && commonLocalizationData;

    if (isLocalizationDataNotNull) {
        return {...commonLocalizationData, ...specificLocalizationData};
    }

    return null;
};

const fetchLocalization = async (languageCode) => {
    let currentLanguageCode = languageCode;
    let localizationData = await fetchLocalizationByLanguageCode(languageCode);

    if (!localizationData) {
        const defaultLanguageCode = languageService.getDefaultLanguageCode();
        const isNotDefaultLanguageCode = languageCode !== defaultLanguageCode;

        if (isNotDefaultLanguageCode) {
            currentLanguageCode = defaultLanguageCode;
            localizationData = await fetchLocalizationByLanguageCode(defaultLanguageCode);
        }
    }

    return {currentLanguageCode, localizationData};
};

let localizedStrings;

const initLocalizations = async (languageCode) => {
    const {currentLanguageCode, localizationData} = (await fetchLocalizations(languageCode)) || {};
    const localizationsData = {
        default: defaultLocalizations,
        [currentLanguageCode]: localizationData,
    };

    localizedStrings = new LocalizedStrings(localizationsData, {logsEnabled: false});

    if (currentLanguageCode) {
        localizedStrings.setLanguage(currentLanguageCode);
    }
};

// Only for storybook
const initDefaultLocalizations = (languageCode) => {
    const localizationsData = {
        default: defaultLocalizations,
    };

    localizedStrings = new LocalizedStrings(localizationsData, {logsEnabled: false});

    localizedStrings.setLanguage(languageCode);
};

const getLocalizedLanguage = () => {
    return localizedStrings?.getLanguage();
};

const getLocalizedStrings = () => localizedStrings;

export {getLocalizedLanguage, getLocalizedStrings, initDefaultLocalizations, initLocalizations};
